import React, { useContext } from 'react';
import { MuiCookieTooltip } from '../../libs/mui/MuiCookieTooltip';
import Button from '@material-ui/core/Button';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import { Tr } from '@lsoft/translate';
import { trAddToCart, trPreOrderNow } from './Product/Product.tr';
import { ShopProductContext } from '../container/shop/ShopProduct';
import { ShopModeContext } from './ShopMode/ShopMode';
import { Session } from '../container/shop/Session';
import { LsSpinnerIcon } from '@lsoft/shared/components/ui/LsSpinnerIcon';
import { CartContext } from '@lsoft/shared/shop/old_contexts/CartContext';

export const ProductCartAddButton = () => {
	const {
		functions: { product_add_to_cart },
		data: { presale, sku, max_stock_available },
	} = useContext(ShopProductContext);
	const { setUseSaveSessionResult, USE_SAVE_SESSION_RESULT } = useContext(
		Session.Context,
	);
	const cartCtx = useContext(CartContext);
	const positionAmount = _.get(cartCtx, ['POSITIONS', sku, 'AMOUNT'], 0);
	const max_stock_amount_reached =
		max_stock_available && positionAmount >= max_stock_available;

	const { disable_customer_order } = useContext(ShopModeContext);
	return (
		<MuiCookieTooltip>
			<Button
				color={'primary'}
				fullWidth
				size={'large'}
				startIcon={
					USE_SAVE_SESSION_RESULT ? <LsSpinnerIcon /> : <ShoppingCartIcon />
				}
				variant={'contained'}
				onClick={() => {
					setUseSaveSessionResult(true);
					product_add_to_cart(1);
				}}
				disabled={
					disable_customer_order ||
					USE_SAVE_SESSION_RESULT ||
					max_stock_amount_reached
				}
			>
				<Tr tr={!presale ? trAddToCart : trPreOrderNow} />
			</Button>
		</MuiCookieTooltip>
	);
};
